import { GetServerSideProps } from "next";
import { serverSideTranslations } from "../../../common/utility/serverSideTranslations";
import { getSelectorsByUserAgent } from "react-device-detect";
import { SingleSUGQuestionPage } from "../../../domains/qi/pages/questionPage/singleSUGQuestionPage";
import { getCachedCourses } from "../../../domains/qi/services/cachedCourseService";
import { convertLangToXLocale } from "../../../domains/qi/services/utiltyService";
import { IKunduzRequest } from "../../../common/interfaces";
import { initalizeMiddlewares } from "../../../common/middlewares";
import { saveContentLangToCookie } from "../../../common/services/utilityService";
import { getCachedHeaderItems } from "../../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../../common/services/cachedHeaderBanner";

export default function Index(props) {
  return <SingleSUGQuestionPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
  res,
  locale,
  query,
}) => {
  await initalizeMiddlewares(req, res, "");
  const { kz_user_token } = req.cookies;
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "en";

  if (!query.questionSlug || !lang) {
    return {
      notFound: true,
    };
  }
  const slug = query.questionSlug as string;
  const xLocale = convertLangToXLocale(lang);
  saveContentLangToCookie(lang, { res });

  let id;
  // try get id
  try {
    id = (slug as string).match(/-(\d+)$/)[1];
  } catch (error) {
    return {
      notFound: true,
    };
  }

  const question = await (
    req as IKunduzRequest
  ).elasticClient.getSingleUSQuestionById(xLocale, id);
  const headerItems = await getCachedHeaderItems(lang, "student");
  const courses = await getCachedCourses(lang);
  const headerBanner = await getCachedHeaderBanner(lang);

  if (!question || question.is_deleted) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      question,
      isMobile,
      isAuth: !!kz_user_token,
      lang,
      query,
      courses,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_common",
      ])),
    },
  };
};
